export const SEGMENT_TEST_ID = "segmented-control-segment";
